import React, { Fragment } from 'react';

import { Menu, Transition } from '@headlessui/react';
import { Float } from '@headlessui-float/react';

import { twMerge } from 'tailwind-merge';

import type { DropdownMenuItemType } from './dropdown-menu-item';
import DropDownMenuItem from './dropdown-menu-item';

interface DropdownMenuProps {
  menuButton: (isOpen: boolean) => React.ReactNode;
  items: DropdownMenuItemType[];
  menuButtonClassName?: string;
  menuItemsClassName?: string;
  autoplacement?: boolean;
  position?: React.ComponentProps<typeof Float>['placement'];
  strategy?: React.ComponentProps<typeof Float>['strategy'];
}

const DropdownMenu: React.FC<DropdownMenuProps> = ({
  menuButton,
  menuButtonClassName,
  menuItemsClassName,
  items,
  position,
  strategy = 'absolute',
  autoplacement,
}) => {
  const MenuButtonClassname = twMerge(
    'relative appearance-none',
    menuButtonClassName,
  );
  const MenuItemsClassname = twMerge(
    'bg-white rounded-lg shadow-xl p-1 border overflow-y-scroll w-52',
    menuItemsClassName,
  );

  return (
    <Menu as="div" className="relative">
      {({ open }) => (
        <>
          <Float
            autoPlacement={autoplacement}
            placement={position}
            strategy={strategy}
            offset={4}
          >
            <Menu.Button className={MenuButtonClassname} as="span">
              {menuButton(open)}
            </Menu.Button>

            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items className={MenuItemsClassname}>
                {items.map((item) => (
                  <DropDownMenuItem
                    key={item.key}
                    type={item.type}
                    label={item.label}
                    variant={item.variant}
                    leadingElement={item.leadingElement}
                    onClick={item.onClick}
                  />
                ))}
              </Menu.Items>
            </Transition>
          </Float>
        </>
      )}
    </Menu>
  );
};

export default DropdownMenu;
